import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()

export class ScheduleService {

  public baseUrl: string;

  constructor(private _http: Http) {
    this.baseUrl = environment.apiUrl;
  }

  getList(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.get(this.baseUrl + 'schedule?page=' + data.page + '&limit=' + data.limit, { headers: headers })
      .map(res => res.json());
  }

  newScheduleList(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.get(this.baseUrl + 'schedule', { headers: headers })
      .map(res => res.json());
  }

  newSchedule(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.post(this.baseUrl + 'schedule', json, { headers: headers })
      .map(res => res.json());
  }

  getSchedule(data: any) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.get(this.baseUrl + 'schedule/' + data.id, { headers: headers })
      .map(res => res.json());
  }

  deleteSchedule(data: any) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.delete(this.baseUrl + 'schedule/' + data.id, { headers: headers })
      .map(res => res.json());
  }

  editSchedule(data: any) {

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    delete data.auth_token;
    let json = JSON.stringify(data);

    return this._http.put(this.baseUrl + 'schedule/' + data.id, json, { headers: headers })
      .map(res => res.json());
  }

  getuser(data: any) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.get(this.baseUrl + 'user-auth/' + data.id, { headers: headers })
      .map(res => res.json());
  }

  getlistUser(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.get(this.baseUrl + 'user-auth?page=' + data.page + '&limit=' + data.limit, { headers: headers })
      .map(res => res.json());
  }

  /*   getSchedulesByIdAgent(data: any) {
      let json = JSON.stringify(data);
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', 'Bearer ' + data.auth_token);
      console.log("test compile");
      return this._http.post(this.baseUrl+'schedule-by-agent/', json, { headers: headers })
        .map(res => res.json());
    } */

  _getSchedulesByIdAgent(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    console.log("id Agente: " ,data.id_agent);
    return this._http.get(this.baseUrl + 'schedules-by-agent/'+ data.id_agent, { headers: headers })
      .map(res => res.json());
  }

  getSchedulesByIdAgentAndType(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.post(this.baseUrl + 'schedule-by-agent-type', json, { headers: headers })
      .map(res => res.json());
  }

  getScheduleTypes(data: any) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.get(this.baseUrl + 'schedule-types', { headers: headers })
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend/src/app/admin/schedule/schedule.service.ts